import { render, staticRenderFns } from "./BulkAttachments.vue?vue&type=template&id=6c08b229"
import script from "./BulkAttachments.vue?vue&type=script&lang=js"
export * from "./BulkAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports